<template>
  <div class="content">
    <div class="toppng">
      <img :src="picOne" alt="" class="imgcode">
<!--      ../../assets/img/toutu.png-->
    </div>
    <div class="allbox">
      <div class="bluebg">
        <div class="line_left">
      <span class="name">
         <img src="../../assets/img/flower.png" alt="" class="flower">
        +86：</span>
          <input type="text" placeholder="请输入您的联系方式" v-model="phone" class="lineinput">
        </div>
        <div class="line_left2">
      <span class="name">
        <img src="../../assets/img/flower.png" alt="" class="flower">
         验证码：</span>
          <input type="text" placeholder="请输入验证码" v-model="code" class="lineinput2">
          <el-button :disabled="disabled" @click="sendcode" class="sendcode" style="float: left">{{btntxt}}</el-button>
        </div>
        <div class="btn" @click="submit">提交</div>
        <div class="right_tit">
          <p class="p2">注册即同意 <span class="p2wor">《房品优选用户服务协议》、
        《房品优选隐私政策》</span></p>
        </div>
      </div>

    </div>
    <div class="mask" v-show="mask"></div>
    <div v-show="success" class="success">
      <div class="hh">恭喜您注册成功！</div>
      <div class="down"  @click="down">
        下载APP了解更多
      </div>
    </div>
    <div class="toppng"><img :src="picTwo" alt="" class="imgcode"></div>
<!--    ../../assets/img/bottom.png-->
  </div>
</template>

<script>
import { uploadimg } from "@/api/ajax.js";
import {
  clos_encryptDes,
  clos_encryptDes1,
  clos_encryptDes2,
  clos_encryptDesForApp,
  time as initTime,
} from "@/encryption";
import {Toast} from "vant";
import {emailcode,Submit,getimgnow} from "api/ajax";
export default {
  name: "Advertise",
  data() {
    return {
      code:'',//验证码
      phone:'',//电话
      btntxt:"发送验证码",
      disabled:false,
      timesall:60,
      mask:false,
      success:false,
      picOne:'',
      picTwo:''
    };
  },
  computed: {

  },
  mounted() {
    this.getimg()
  },
  methods: {
    down(){
      // window.open('https://apps.apple.com/cn/app/%E6%88%BF%E5%93%81%E4%BC%98%E9%80%89-%E9%80%89%E6%88%BF%E4%B9%B0%E6%88%BF%E5%AE%89%E5%AE%B6%E6%8B%BF%E8%A1%A5%E8%B4%B4%E7%9A%84%E6%96%B0%E6%88%BF%E5%B9%B3%E5%8F%B0/id1492786478')
    window.location.href="https://apps.apple.com/cn/app/%E6%88%BF%E5%93%81%E4%BC%98%E9%80%89-%E9%80%89%E6%88%BF%E4%B9%B0%E6%88%BF%E5%AE%89%E5%AE%B6%E6%8B%BF%E8%A1%A5%E8%B4%B4%E7%9A%84%E6%96%B0%E6%88%BF%E5%B9%B3%E5%8F%B0/id1492786478"
    },
    sendcode(){
      this.timesall=60;
      this.timer();
    },
    async getimg() {
      let time = this.time()
      let args = {
        action: "account.getExtendPicture",
        timestamp:time
      };
      getimgnow(args). then(res=>{
       this.picOne=res.data[0].picOne
        this.picTwo=res.data[0].picTwo
      }). catch(error=>{
        Toast.fail(error.errorMessage);
      })
    },

    changetimer() {
      if (this.timesall > 0) {
        this.disabled=true;
        this.timesall--;
        this.btntxt=this.timesall+"秒";
        setTimeout(this.changetimer, 1000);
      } else{
        this.timesall=0;
        this.btntxt="发送验证码";
        this.disabled=false;
      }
    },
    //发送手机验证码倒计时
    async timer() {
      if(this.phone==''){
        Toast.fail('电话不能为空');
        return false
      }
      // if (this.timesall > 0) {
        let time = this.time()
        let args = {
          action: "account.sendVerificationCode",
          phoneNumber :this.phone,//电话
          timestamp:time
        };
        emailcode(args). then(res=>{
              Toast.success('发送成功');
              this.changetimer()
        }). catch(error=>{
            // console.log(error,'9999')
          Toast.fail(error.errorMessage);
        })
    },


    async submit() {
      if(this.phone==''){
        Toast.fail('电话不能为空');
        return false
      }
      if(this.code==''){
        Toast.fail('验证码不能为空');
        return false
      }
      let time = this.time()
      let args = {
        action: "account.verifyCode",
        verifyCode:this.code,//验证码
        phoneNumber:this.phone,//电话
        timestamp:time
      };
      Submit(args). then(res=>{
        console.log(res,'9999')

        this.mask=true
        this.success=true
      }). catch(error=>{
// console.log(error.errorMessage,'是嘛')
        Toast.fail(error.errorMessage);
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.content{
  position: relative;
  .mask{
    position: absolute;
    width:100% ;
    height: 100%;
    z-index: 9;
    background-color:rgba(0,0,0.4,0.5);
    top: 0;
    left: 0;
  }
  .success{
    position: absolute;
    width:260px;
    height: 180px;
    z-index: 99;
    background-color:white;
    border-radius: 6px;
    top:30%;
    left: 16%;
    .hh{
      color:#333333;
      font-weight: bold;
      text-align: center;
      font-size: 20px;
      height: 60px;
      line-height: 60px;
    }
    .down{
      width: 80%;
      margin: 25px auto 5px;
      color: white;
      text-align: center;
      height: 46px;
      border-radius: 6px;
      line-height: 46px;
      background-color:rgb(245,154,40);
      font-size: 16px;
      //color: white;
    }
  }
  .toppng{
    .imgcode{
      width: 100%;
    }
  }
 .allbox{
   padding: 16px;
   background-color:#333aed;

   .bluebg{
     background:white ;
     padding: 8px;
     border-radius: 8px;
     box-shadow: 0 5px 12px 0 rgba(0,0,0,.5);
     .line_left{
       height: 60px;
       line-height: 60px;
       border-bottom: 0.5px solid #F0F0F0;
       .uppng{
         width: 95.99em;
         height: 86.99em;
       }
       .name{
         display: inline-block;
         width: 88px;
         font-size: 14px;
         .flower{
           width: 8px;
           height: 8px;
           margin-right: 4px;

         }
       }
       .lineinput{
         outline: none;
         border:none;
         height: 57px;
         font-size: 13px;
       }
     }
     .line_left2{
       height: 60px;
       line-height: 60px;
       border-bottom: 0.5px solid #F0F0F0;
       display: flex;
       justify-content: space-between;
       .uppng{
         width: 95.99em;
         height: 86.99em;
       }
       .name{
         display: inline-block;
         width: 88px;
         font-size: 14px;
         .flower{
           width: 8px;
           height: 8px;
           margin-right: 4px;

         }
       }
       .lineinput2{
         outline: none;
         border:none;
         height: 57px;
         font-size: 13px;
         width: 135px;
       }
       .sendcode{
         width: 100px;
         color:rgb(245,154,40);
         border: none;
       }
     }
     .right_tit{
       font-size: 14px;
       font-weight: 600;
       color: #444;
       line-height: 20px;
       //padding-bottom: 30px;
       padding: 0 10px 30px;
       p{
         font-size: 14px;
         font-weight: normal;
       }
       .p2{
         font-size: 14px;
         font-weight: bold;
         color: #333333;
         height: 27px;
         line-height: 27px;
         .p2wor{
           color: rgb(245,154,40);
         }
       }
     }
     .btn{
       width: 100%;
       margin: 25px auto 5px;
       color: white;
       text-align: center;
       height: 46px;
       border-radius: 6px;
       line-height: 46px;
       background-color:rgb(245,154,40);
       font-size: 16px;
     }
   }

 }

}
</style>
